<ejs-dialog
  [visible]="visible"
  width="80vw"
  height="85vh"
  [showCloseIcon]="true"
  [isModal]="true"
  [header]="title"
  (open)="onDialogOpen()"
  (close)="onDialogClose()">
  <ejs-pdfviewer
    #pdfViewer
    [resourceUrl]="resourceUrl"
    [enableDownload]="true"
    [enablePrint]="true"
    [enableToolbar]="true"
    height="72vh">
  </ejs-pdfviewer>
</ejs-dialog>
